import { RouteProps } from '../../routes/AppRouter'
import { Grid, Button, TextField, Accordion, AccordionDetails, AccordionSummary, Box, FormControl, FormControlLabel, MenuItem, Select, Switch, Typography } from '@material-ui/core'
import { useForm } from '../../common/utils/form-generation/useForm'
import { useTranslation } from 'react-i18next'
import { navigate } from '@reach/router'
import { URL_PATIENT_PGD_SHOW, URL_PGD_TEST } from '../../routes/routes-constants'
import { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { Query, QueryParam } from '../../common/api/Query'
import { Project, ProjectDTO, emptyProjectDTO } from '../../modules/projects/models/Project'
import { getProjectContainer } from '../../container/project-module'
import { ProjectService } from '../../modules/projects/services/ProjectService'
import { PROJECT_SERVICE_KEY } from '../../modules/projects'
import { userGenders } from '../../modules/users/enums/GenderType'
import { getFileContainer } from 'container/file-module'
import { FileService } from 'modules/files/services/FileService'
import { FILE_SERVICE_KEY } from 'modules/files'
import { Bedfile, Panel } from 'modules/files/models/File'
import { useStyles } from '../../components/entity-page/EntityPage.styles'
import { ExpandMore } from '@material-ui/icons'
import { commonStyles } from 'common/styles/Styles'
import { getMutationsPositionContainer } from 'container/mutationsPositions-module'
import { MUTATIONS_POSITION_SERVICE_KEY } from 'modules/mutationsPosition'
import { MutationsPositionService } from 'modules/mutationsPosition/services/MutationsPositionService'

const projectService = getProjectContainer().get<ProjectService>(PROJECT_SERVICE_KEY)
const fileService = getFileContainer().get<FileService>(FILE_SERVICE_KEY)
const mutationService = getMutationsPositionContainer().get<MutationsPositionService>(MUTATIONS_POSITION_SERVICE_KEY)

export type FormProps = RouteProps & {
  project: Project | undefined
  patientID: string
}

type InfoVariant = {
  id?: string,
  description: string,
  type: string,
  chromosome: string,
  position?: number,
  start?: number,
  end?: number,
  isSame?: boolean,
  cis: boolean,
  trans: boolean,
  allGenes: boolean
}

export const Detail = (props: FormProps) => {
  const { t } = useTranslation()
  const [panels, setPanels] = useState<Panel[]>([])
  const [bedfiles, setBedfiles] = useState<Bedfile[]>([])
  const [geneSelected, setGeneSelected] = useState<string>('')
  const [panelSelected, setPanelSelected] = useState<Panel>()
  const [motherInformation, setMotherInformation] = useState<InfoVariant[]>([])
  const [fatherInformation, setFatherInformation] = useState<InfoVariant[]>([])
  const classes = useStyles({})
  const styles = commonStyles()
  
  useEffect(() => {
    if (!geneSelected) return
    fileService
      .getBedfiles(
        new Query({
          query: [new QueryParam('gene', geneSelected)],
        })
      )
      .subscribe((res) => {
        setBedfiles(res.items)
      })
  }, [geneSelected])

  useEffect(() => {
    fileService.getPanels(new Query({})).subscribe((res) => {
      setPanels(res.items)
    })
  }, [])

  useEffect(() => {
    
    if (!props.project) {
      return
    }

    fileService.getBedfileByID(props.project.toDTO().bedfileID).subscribe((res) => {
      res && setBedfiles([res])
    })
  }, [props.project])

  useEffect(() => {
    if (!props.project) {
      return
    }
    setData(props.project.toDTO())
  }, [props.project])

  

  const { handleChange, handleSubmit, data, setData, errors } = useForm<ProjectDTO>({
    validations: {
      name: {
        required: {
          value: true,
          message: t('projectNameNotValidError'),
        },
      },
    },

    onSubmit: () => {
      function storeCb(value: Project | undefined) {
        if (value) {
          goToProyects().then()
        }
      }

      if (!props.project) {
        projectService
          .add({
            ...data,
            id: uuidv4(),
            pathology: panelSelected?.pathology || '',
          })
          .subscribe((value) => storeCb(value))
        return
      }

      projectService.update({ ...data }).subscribe((value) => storeCb(value))
    },

    initialValues: props.project ? props.project.toDTO() : emptyProjectDTO(props.patientID),
  })

  const goToProyects = () => props.patientID ? navigate(URL_PATIENT_PGD_SHOW.replace(':id', props.patientID)) : navigate(URL_PGD_TEST)

  const getBedfileName = (bedID: string) => {
    let filtered = bedfiles.filter((b) => b.id == bedID)

    if (filtered.length > 0) {
      return filtered[0].name
    }
    return ''
  }

  const getPanelName = (panelID: string) => {
    let filtered = panels.filter((b) => b.id == panelID)
   
    if (filtered.length > 0) {
      return filtered[0].gene
    }
    return ''
  }

      
  useEffect(() => {
    if (!props.project) {
        return
    }
    mutationService.getByProjectID(data.mutationPositionsID).subscribe(res => {
        let auxMaternal: InfoVariant[] = []
        let auxPaternal: InfoVariant[] = []
       if (res) {res.items.map(variant => {
            let aux: InfoVariant = {
                id: variant.id,
                chromosome: variant.chromosome,
                type: variant.type,
                description: variant.description,
                cis: variant.cis,
                trans: variant.trans,
                allGenes: variant.allGenes
            }

            if (variant.type === "SNP" ) aux.position = variant.position
            else {
                aux.start = variant.start
                aux.end = variant.end
            }
            if (variant.paternal === 'mother') auxMaternal.push(aux)
            if (variant.paternal === 'father') auxPaternal.push(aux)
        })
    setMotherInformation(auxMaternal)
    setFatherInformation(auxPaternal)

        }
    })
}, [data])
  const variantTypeForm = (currentVariant: InfoVariant, variantPosition: number) => {

    switch (currentVariant.type) {
        case "SNP":
          return (
              <Grid>
              <Box style={{
                color:"rgba(125,191,220,1)", 
                fontSize:"larger",
                textAlign: "left", 
                marginBottom: "10px",
                marginTop: "20px"
                }}>
                  Position of interest
              </Box>
              <Grid item style={{display: "flex", justifyContent: "flex-start"}}>
                <Grid item xs={3} >
                  <TextField 
                    style={{marginRight: "10px"}}
                    id={'chromosome'}
                    variant={'outlined'}
                    type={'string'}
                    value={(currentVariant && currentVariant.chromosome)}
                    label={t('chrom')}
                    InputProps={{
                      readOnly: true,
                    }}
                      />
                </Grid>
                <Grid item xs={8}>
                  <TextField 
                    fullWidth
                    variant={'outlined'}
                    type={'string'}
                    value={(currentVariant && currentVariant.position) || ''}
                    label={t('position')}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              </Grid>
              {variantPosition === 1 && (
                  <Grid style={{display: "flex", width: "50px"}}>
                    <FormControlLabel
                      className={styles.toggle2}
                      control={<Switch/>}
                      label={'cis'}
                      style={{ marginLeft: '1%' }}
                      checked={currentVariant.cis === true}
                      disabled
                    />
                    <FormControlLabel
                      className={styles.toggle2}
                      control={<Switch/>}
                      label={'trans'}
                      style={{ marginLeft: '1%' }}
                      checked={currentVariant.trans === true}
                      disabled
                    />
                  </Grid>
              )}
              </Grid>
          )
          
          // De momento el unico diferente sera SNP
          default:
            return (
              <Grid>
                <Box 
                  style={{
                  color:"rgba(125,191,220,1)", 
                  fontSize:"larger",
                  textAlign: "left", 
                  marginBottom: "10px",
                  marginTop: "20px"
                  }}
                >
                  Position of interest
                </Box>
                <Grid item xs= {11}style={{display: "flex", justifyContent: "flex-start"}}>
                  <Grid item xs={2} >
                    <TextField 
                      style={{marginRight: "10px"}}
                      id={'chrom'}
                      variant={'outlined'}
                      type={'string'}
                      value={(currentVariant.chromosome)}
                      label={t('chrom')}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <TextField 
                      fullWidth
                      variant={'outlined'}
                      type={'string'}
                      value={(currentVariant && currentVariant.start) || ''}
                      label={t('Start')}
                    />
                  </Grid>
                  <Grid item xs={5} style={{marginLeft:"5px"}}>
                    <TextField 
                      fullWidth
                      variant={'outlined'}
                      type={'string'}
                      value={(currentVariant && currentVariant.end) || ''}
                      label={t('End')}
                      disabled/>
                  </Grid>
                </Grid>
                {variantPosition === 1 && (
                <Grid style={{display: "flex", width: "50px"}}>
                  <FormControlLabel
                    className={styles.toggle2}
                    control={<Switch/>}
                    label={'cis'}
                    style={{ marginLeft: '1%' }}
                    checked={currentVariant.cis === true}
                  />
                  <FormControlLabel
                    className={styles.toggle2}
                    control={<Switch/>}
                    label={'trans'}
                    style={{ marginLeft: '1%' }}
                    checked={currentVariant.trans === true}
                    disabled
                  />
                </Grid>
                )}
                <Grid style={{ width: "100px"}}>     
                  <FormControlLabel
                    className={styles.toggle3}
                    control={<Switch/>}
                    label={'select all genes'}
                    style={{ marginLeft: '1%' }}
                    checked={currentVariant.allGenes}
                    disabled
                  />
                </Grid>
              </Grid>
            )
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2} style={{ marginBottom: '1%' }}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant={'outlined'}
            error={errors['name'] !== undefined}
            id={'name'}
            type={'string'}
            onChange={(event) => handleChange('name', event.target.value)}
            value={(data && data.name) || ''}
            label={t('projectName')}
            helperText={errors['name']}
            inputProps={{
              readOnly: true,
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            variant={'outlined'}
            error={errors['nameHer'] !== undefined}
            id={'nameHer'}
            type={'string'}
            onChange={(event) => handleChange('nameHer', event.target.value)}
            value={(data && data.nameHer) || ''}
            label={t('nameHer')}
            helperText={errors['nameHer']}
            inputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant={'outlined'}
            error={errors['dobHer'] !== undefined}
            id={'dobHer'}
            type={'string'}
            value={( () => { if (!data.dobHer || typeof data.dobHer !== 'string') return '';
              const date = new Date(data.dobHer);
              if (isNaN(date.getTime())) return '';

              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const year = String(date.getFullYear());

              const format = t('dateFormat');

              return format
                  .replace('MM', month)
                  .replace('dd', day)
                  .replace('yyyy', year);
          })()}
            label={t('dobHer')}
            inputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant={'outlined'}
            error={errors['nifHer'] !== undefined}
            id={'nifHer'}
            type={'string'}
            onChange={(event) => handleChange('nifHer', event.target.value)}
            value={(data && data.nifHer) || ''}
            label={t('nifHer')}
            helperText={errors['nifHer']}
            inputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant={'outlined'}
            error={errors['nameHim'] !== undefined}
            id={'nameHim'}
            type={'string'}
            onChange={(event) => handleChange('nameHim', event.target.value)}
            value={(data && data.nameHim) || ''}
            label={t('nameHim')}
            helperText={errors['nameHim']}
            inputProps={{
              readOnly: true,
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            variant={'outlined'}
            error={errors['dobHim'] !== undefined}
            id={'dobHim'}
            type={'string'}
            value={( () => { if (!data.dobHim || typeof data.dobHim !== 'string') return '';
              const date = new Date(data.dobHim);
              if (isNaN(date.getTime())) return '';

              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const year = String(date.getFullYear());

              const format = t('dateFormat');

              return format
                  .replace('MM', month)
                  .replace('dd', day)
                  .replace('yyyy', year);
          })()}
            label={t('dobHim')}
            inputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant={'outlined'}
            error={errors['nifHim'] !== undefined}
            id={'nifHim'}
            type={'string'}
            onChange={(event) => handleChange('nifHim', event.target.value)}
            value={(data && data.nifHim) || ''}
            label={t('nifHim')}
            helperText={errors['nifHim']}
            inputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid container xs={12} justify='space-around'>
        <Grid container xs={6} spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant={'outlined'}
            error={errors['firstGene'] !== undefined}
            id={'firstGene'}
            type={'string'}
            value={(data && data.firstGene) || ''}
            label={t('firstGene')}
            helperText={errors['firstGene']}
            inputProps={{
              readOnly: true,
            }}
          />
        </Grid>  </Grid>
        <Grid container xs={6} spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant={'outlined'}
            error={errors['lastGene'] !== undefined}
            id={'lastGene'}
            type={'string'}
            value={(data && data.lastGene) || ''}
            label={t('lastGene')}
            helperText={errors['lastGene']}
            inputProps={{
              readOnly: true,
            }}
          />  </Grid>
        </Grid>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant={'outlined'}
            error={errors['panelID'] !== undefined}
            id={'panelID'}
            type={'string'}
            //@ts-ignore
            value={getPanelName(data.panelID)}
            label={t('panel')}
            helperText={errors['panelID']}
            inputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant={'outlined'}
            error={errors['bedfileID'] !== undefined}
            id={'bedfileID'}
            type={'string'}
            //@ts-ignore
            value={getBedfileName(data.bedfileID)}
            label={t('bedfile')}
            helperText={errors['bedfileID']}
            inputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant={'outlined'}
            error={errors['pathology'] !== undefined}
            id={'pathology'}
            type={'string'}
            value={(panelSelected && panelSelected.pathology) || (data && data.pathology) || ''}
            label={t('pathology')}
            helperText={errors['pathology']}
            inputProps={{
              readOnly: true,
              disabled: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant={'outlined'}
            error={errors['receptionDate'] !== undefined}
            id={'receptionDate'}
            type={'string'}
            value={( () => { if (!data.receptionDate || typeof data.receptionDate !== 'string') return '';
              const date = new Date(data.receptionDate);
              if (isNaN(date.getTime())) return '';

              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const year = String(date.getFullYear());

              const format = t('dateFormat');

              return format
                  .replace('MM', month)
                  .replace('dd', day)
                  .replace('yyyy', year);
          })()}

            label={t('receptionDate')}
            inputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            variant={'outlined'}
            error={errors['reportDate'] !== undefined}
            id={'reportDate'}
            type={'string'}
            value={( () => { if (!data.reportDate || typeof data.reportDate !== 'string') return '';
              const date = new Date(data.reportDate);
              if (isNaN(date.getTime())) return '';

              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const year = String(date.getFullYear());

              const format = t('dateFormat');

              return format
                  .replace('MM', month)
                  .replace('dd', day)
                  .replace('yyyy', year);
          })()}
            label={t('reportDate')}
            inputProps={{
              readOnly: true,
            }}
          />
        </Grid>
      </Grid>
      <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMore/>} // Icono para expandir el acordeón
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Typography
                                style={{
                                    color:"rgba(125,191,220,1)", 
                                    fontWeight:"bold", 
                                    fontSize:"large", 
                                    textAlign: "left", 
                                    marginBottom: "10px"
                                    }}>
                                    {t('geneticInformation').toUpperCase()}

                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
            <Grid>
                <Grid item xs={12} style={{
                display: "flex",
                
                }}>
                    <Grid item xs={6} style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",

                     }}>
                        
                        {motherInformation.length > 0 ? (
                            motherInformation.map((inf, i) => {
                              return (
                                <Grid 
                                    style={{
                                    width: "100%",
                                    marginBottom: '20px'
                                    
                                 }}>
                                    <Box style={{
                                        color:"rgba(125,191,220,1)", 
                                        fontWeight:"bold", 
                                        fontSize:"larger", 
                                        textAlign: "left", 
                                        marginBottom: "10px",

                                     }}>
                                            Maternal Variant {motherInformation.length > 1 &&  ` ${i+1}`}
                                    </Box>
                                    <Grid item xs={11} style={{display: 'flex', flexDirection: 'row'}} >
                                            <TextField
                                                
                                                fullWidth
                                                variant={'outlined'}
                                                // error={errors['variatnDescription'] !== undefined}
                                                id={`variantDescription${i}`}
                                                type={'string'}
                                                value={(inf && inf.description) || ''}
                                                label={t('variantDescription')}
                                                InputProps={{
                                                  readOnly: true,
                                                }}
                                            />
                                        <Grid xs={2}/>
                                    </Grid>
                                    <Grid item xs={4} style={{marginTop: '10px'}}>
                                        <TextField
                                            id={`typeVariant${i}`}
                                            fullWidth
                                            style={{textAlign: 'left'}}
                                            value={ (inf&& inf.type )|| "Type"}
                                            InputProps={{
                                              readOnly: true,
                                            }}
                                            variant="outlined"
                                           />
                                        
                                    </Grid>
                                    {inf.type !== "Type" && variantTypeForm(inf, i)}
                                </Grid>
                            )}) 
                        ): (
                            <Box style={{
                                color:"rgba(125,191,220,1)", 
                                fontWeight:"bold", 
                                fontSize:"larger", 
                                textAlign: "left", 
                                marginBottom: "10px",
                             }}>
                                    Maternal Variant
                            </Box>
                        )}
                        <Box style={{
                            display: "flex",
                            alignItems: "start",
                            borderTop:" 1px solid rgba(125,191,220,1) ",
                            width: "558px",
                            marginRight: "20px"
                         }}>
                           
                        </Box>
                    </Grid>

                
                    <Grid item xs={6} style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",

                     }}>
                        
                        {fatherInformation.length > 0 ? (
                            fatherInformation.map((inf, i) => {
                              return (
                                <Grid 
                                    style={{
                                    width: "100%",
                                    marginBottom: '20px'
                                 }}>
                                    <Box style={{
                                        color:"rgba(125,191,220,1)", 
                                        fontWeight:"bold", 
                                        fontSize:"larger", 
                                        textAlign: "left", 
                                        marginBottom: "10px",

                                     }}>
                                            Paternal Variant {fatherInformation.length > 1 &&  ` ${i+1}`}
                                    </Box>
                                    <Grid item xs={11} style={{display: 'flex', flexDirection: 'row'}}>
                                        <TextField
                                            
                                            fullWidth
                                            variant={'outlined'}
                                            // error={errors['variatnDescription'] !== undefined}
                                            id={`variantDescription${i}`}
                                            type={'string'}
                                            value={(inf && inf.description) || ''}
                                            label={t('variantDescription')}
                                            InputProps={{
                                              readOnly: true,
                                            }}
                                        />
                                        <Grid xs={2}/>
                                    </Grid>
                                    <Grid item xs={8} style={{display:'flex', flexDirection:'row', marginTop: '10px'}}>
                                        <TextField
                                            id={`typeVariant${i}`}
                                            fullWidth
                                            style={{textAlign: 'left'}}
                                            value={ (inf&& inf.type )|| "Type"}
                                            InputProps={{
                                              readOnly: true,
                                            }}
                                             variant="outlined"
                                           />

                                        
                                        {/* <div style={{width: "27%", display: "flex", justifyContent: "space-between"}}> */}
                                          <FormControlLabel
                                                    className={styles.toggle2}
                                                    control={<Switch/>}
                                                    label={'Same as maternal variant'}
                                                    style={{ marginLeft: '1%' }}
                                                    checked={inf.isSame == true}
                                                    disabled
                                                  />
                                            
                                        {/* </div> */}
                                    </Grid>
                                    {inf.type !== "Type" && variantTypeForm(inf, i)}
                                </Grid>
                            )}) 
                        ):  (
                            <Box  style={{
                              color:"rgba(125,191,220,1)", 
                              fontWeight:"bold", 
                              fontSize:"larger", 
                              textAlign: "left", 
                              marginBottom: "10px",

                              }}>
                                    Paternal Variant
                            </Box>
                        )}
                        <Box style={{
                          display: "flex",
                          alignItems: "start",
                          borderTop:" 1px solid rgba(125,191,220,1) ",
                          width: "568px"

                        }}>
                      </Box>
                    </Grid>
                </Grid>
            </Grid>
            </AccordionDetails>
            </Accordion>
      <Grid item xs={2} style={{marginBottom: "2.5%", marginTop: "2.5%"}}>
        <Button
          fullWidth
          className={classes.button}
          onClick={() => goToProyects()}
          variant={'contained'}>
          {t('back')}
        </Button>
      </Grid>
    </form>
  )
}
